(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('kyor-footer')) {
    customElements.define('kyor-footer', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(min-width: 799px)');
        this.syncMenus = () => {
          this.querySelectorAll('.kyor-footer__menu').forEach(menu => { menu.open = this.media.matches; });
        };
        this.media.addEventListener('change', this.syncMenus);
        this.syncMenus();
      }
      disconnectedCallback() {
        this.media?.removeEventListener('change', this.syncMenus);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 798px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);
      this.announcementSection = document.querySelector('.shopify-section-group-header-group .announcement-bar')?.closest('.shopify-section');
      if (this.announcementSection) {
        this.announcementSection.classList.add('kyor-announcement-section');
        this.announcementResizeObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--kyor-announcement-height', `${this.announcementSection.offsetHeight}px`);
        });
        this.announcementResizeObserver.observe(this.announcementSection);
      }

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver?.disconnect();
      this.announcementResizeObserver?.disconnect();
      this.announcementSection?.classList.remove('kyor-announcement-section');
      document.documentElement.style.removeProperty('--kyor-announcement-height');
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.kyor-mobile-menu[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary').focus();
  });
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyor-shipping-calculator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kyor-shipping-calculator')) {
  customElements.define('kyor-shipping-calculator', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.country = this.form.elements.country;
      this.province = this.form.elements.province;
      this.result = this.querySelector('[role="status"]');
      this.button = this.querySelector('button');
      this.root = window.Shopify?.routes?.root || '/';
      const defaultOption = [...this.country.options].find(option => option.value === this.dataset.country || option.text === this.dataset.country);
      if (defaultOption) this.country.value = defaultOption.value;
      this.changeCountry = () => {
        const provinces = JSON.parse(this.country.selectedOptions[0]?.dataset.provinces || '[]');
        this.province.replaceChildren();
        for (const [value, label] of provinces) this.province.add(new Option(label, value));
        this.province.disabled = !provinces.length;
        this.querySelector('[data-province-field]').hidden = !provinces.length;
      };
      this.invalidate = () => {
        this.controller?.abort();
        this.controller = null;
        this.result.textContent = '';
        this.button.disabled = false;
        this.button.textContent = 'CALCULATE SHIPPING RATES';
        this.removeAttribute('aria-busy');
      };
      this.onChange = () => { this.invalidate(); this.changeCountry(); };
      this.onInput = () => this.invalidate();
      this.onSubmit = event => { event.preventDefault(); this.calculate(); };
      this.country.addEventListener('change', this.onChange);
      this.form.addEventListener('input', this.onInput);
      this.form.addEventListener('submit', this.onSubmit);
      this.changeCountry();
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        this.cartObserver = new MutationObserver(() => this.invalidate());
        this.cartObserver.observe(cartItems, { childList:true, subtree:true });
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.cartObserver?.disconnect();
      this.country.removeEventListener('change', this.onChange);
      this.form.removeEventListener('input', this.onInput);
      this.form.removeEventListener('submit', this.onSubmit);
    }
    async request(path, options, signal) {
      const response = await fetch(this.root + path, { ...options, signal, credentials:'same-origin', cache:'no-store' });
      if (!response.ok) {
        const data = await response.json().catch(() => null);
        const messages = data && typeof data === 'object' ? Object.entries(data).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : String(value)}`).join(' ') : '';
        throw new Error(messages || 'Unable to calculate shipping. Please try again or continue to checkout.');
      }
      return response;
    }
    async calculate() {
      this.invalidate();
      if (!this.country.value || this.country.value === '---') {
        this.result.textContent = 'Please select a country.';
        return;
      }
      const controller = new AbortController();
      this.controller = controller;
      const signal = controller.signal;
      this.button.disabled = true;
      this.button.textContent = 'CALCULATING…';
      this.setAttribute('aria-busy', 'true');
      this.result.textContent = 'Calculating shipping rates…';
      const timeout = setTimeout(() => controller.abort(), 25000);
      try {
        const cart = await (await this.request('cart.js', {}, signal)).json();
        if (!cart.item_count) { this.result.textContent = 'Add an item to your cart to calculate shipping rates.'; return; }
        if (!cart.requires_shipping) { this.result.textContent = 'The items in your cart do not require shipping.'; return; }
        const params = new URLSearchParams();
        params.set('shipping_address[country]', this.country.value);
        params.set('shipping_address[zip]', this.form.elements.zip.value.trim());
        if (!this.province.disabled) params.set('shipping_address[province]', this.province.value);
        await this.request('cart/prepare_shipping_rates.json?' + params, { method:'POST' }, signal);
        let rates = null;
        for (let attempt = 0; attempt < 20; attempt++) {
          if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
          const response = await this.request('cart/async_shipping_rates.json?' + params, {}, signal);
          const body = await response.text();
          const data = body.trim() ? JSON.parse(body) : null;
          if (Array.isArray(data?.shipping_rates)) { rates = data.shipping_rates; break; }
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        if (rates === null) throw new Error('Shipping rates are taking longer than expected. Please try again or check shipping at checkout.');
        if (!rates.length) { this.result.textContent = 'No shipping rates are available for this address. Check your details or continue to checkout.'; return; }
        const heading = document.createElement('p');
        heading.textContent = 'Estimated shipping rates:';
        const list = document.createElement('ul');
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:cart.currency || this.dataset.currency });
        for (const rate of rates) {
          const item = document.createElement('li');
          const price = Number(rate.price);
          item.textContent = `${rate.name}: ${Number.isFinite(price) ? formatter.format(price) : rate.price}`;
          list.append(item);
        }
        const note = document.createElement('p');
        note.textContent = 'Final shipping options and costs are confirmed at checkout.';
        this.result.replaceChildren(heading, list, note);
      } catch (error) {
        if (this.controller === controller) this.result.textContent = error.name === 'AbortError' ? 'The request timed out. Please try again.' : error.message;
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) {
          this.button.disabled = false;
          this.button.textContent = 'CALCULATE SHIPPING RATES';
          this.removeAttribute('aria-busy');
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
